import { useNavigate } from "react-router-dom";
import { useState } from "react";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
} from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { ArrowLeft } from "lucide-react";
import { adminService } from "@/lib/database";
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { supabase } from "@/lib/supabase";

export default function AddTeam() {
  // New admin form state
  const [newAdmin, setNewAdmin] = useState({
    name: "",
    email: "",
    phone: "",
    createAuth: true,
    notificationMethod: "email" as "email" | "sms" | "both",
  });

  const navigate = useNavigate();

  const handleCreateAdmin = async () => {
    try {
      if (!newAdmin.name || !newAdmin.email) {
        alert("Please fill in all required fields");
        return;
      }

      const { createAuth, notificationMethod, ...adminData } = newAdmin;

      if (createAuth) {
        // TODO: Move this into the admin service
        const { error } = await supabase.functions.invoke("create-user", {
          method: "POST",
          body: JSON.stringify({
            user: adminData,
            notificationMethod,
            userType: "admin",
          }),
        });

        if (error) {
          throw new Error(error.message || "Failed to create admin");
        }
      } else {
        await adminService.create(adminData, false);
      }

      setNewAdmin({
        name: "",
        email: "",
        phone: "",
        createAuth: true,
        notificationMethod: "email",
      });

      if (createAuth) {
        alert(
          `Member account created successfully! Login credentials have been sent via ${
            notificationMethod === "both"
              ? "both email and sms"
              : notificationMethod
          }.`
        );
      } else {
        alert("Member profile created successfully!");
      }
    } catch (error) {
      console.error("Error creating admin:", error);
      alert("Error creating admin. Please try again.");
    }
  };

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex items-center justify-between">
        <div className="flex space-x-4">
          <Button variant="ghost" onClick={() => navigate(-1)}>
            <ArrowLeft className="h-4 w-4 mr-2" />
            Cancel
          </Button>
          <div>
            <h1 className="text-2xl md:text-3xl font-bold text-gray-900">
              Add New Team Member
            </h1>
            {/* <p className="text-gray-600">Update admin information</p> */}
          </div>
        </div>

        {/* <Button onClick={handle} disabled={saving} className="bg-[#254164] hover:bg-[#1a2d47]">
            <Save className="h-4 w-4 mr-2" />
            {saving ? 'Saving...' : 'Save Changes'}
          </Button> */}
      </div>

      <div className="space-y-2">
        <Card>
          <CardHeader hidden>
            <CardDescription>
              Fill in the details below to create a new member profile.
            </CardDescription>
          </CardHeader>
          <CardContent className="space-y-6">
            <div>
              <div>
                <Label htmlFor="name">Full Name *</Label>
                <Input
                  id="name"
                  value={newAdmin.name}
                  onChange={(e) =>
                    setNewAdmin((prev) => ({ ...prev, name: e.target.value }))
                  }
                />
              </div>
            </div>
            <div>
              <Label htmlFor="email">Email *</Label>
              <Input
                id="email"
                type="email"
                value={newAdmin.email}
                onChange={(e) =>
                  setNewAdmin((prev) => ({ ...prev, email: e.target.value }))
                }
              />
            </div>
            <div>
              <Label htmlFor="phone">Phone</Label>
              <Input
                id="phone"
                value={newAdmin.phone}
                onChange={(e) =>
                  setNewAdmin((prev) => ({ ...prev, phone: e.target.value }))
                }
              />
            </div>
            <div className="flex items-center space-x-2">
              <Switch
                id="create-auth"
                checked={newAdmin.createAuth}
                onCheckedChange={(checked) =>
                  setNewAdmin((prev) => ({ ...prev, createAuth: checked }))
                }
              />
              <Label htmlFor="create-auth">
                Create login account and send credentials
              </Label>
            </div>
            {newAdmin.createAuth && (
              <div className="space-y-2">
                <Label>Send credentials via:</Label>
                <RadioGroup
                  value={newAdmin.notificationMethod}
                  onValueChange={(value: "email" | "sms") =>
                    setNewAdmin((prev) => ({
                      ...prev,
                      notificationMethod: value,
                    }))
                  }
                >
                  <div className="flex items-center space-x-2">
                    <RadioGroupItem value="email" id="email-notification" />
                    <Label htmlFor="email-notification">Email</Label>
                  </div>
                  <div className="flex items-center space-x-2">
                    <RadioGroupItem
                      disabled
                      value="sms"
                      id="sms-notification"
                    />
                    <Label htmlFor="sms-notification">Text Message</Label>
                  </div>
                </RadioGroup>
              </div>
            )}
            <Button onClick={handleCreateAdmin} className="w-full">
              Create Admin
            </Button>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
